var map = {
	"./ksiega_znaku.jpg": "8daa",
	"./logotyp_bez_przedzialu_lat.jpg": "86ba",
	"./logotyp_skala_szarosci_bez_lat.jpg": "b01c",
	"./logotyp_skala_szarosci_z_latami.jpg": "ec12",
	"./logotyp_z_bialym_napisem_bez_dat.png": "261d",
	"./logotyp_z_bialym_napisem_z_datami.png": "48bb",
	"./logotyp_z_latami_1950-2020.jpg": "f5f7",
	"./papier_firmowy.jpg": "9028",
	"./sygnet.jpg": "d91e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "acfa";